module.exports = __webpack_public_path__ + "static/floor-5-d93d82ea9ea4832949ef6ec192f01cd8.png";